// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"b9a41586","775":"33e0addf"}[chunkId] + ".chunk.css";
};